module.exports = __webpack_public_path__ + "img/1761.4fa03622.gif";